<template>
<div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                        <strong>Request Configuration</strong>
                    </div>
                    <!-- <router-link :to="'/dashboardAwblist/'+'-'+'BookingP-ending'+'-'+'ppp'">ookkkk</router-link> -->
                     <b-row>
                        <b-col md="12" >
                            <div class="requestconfig">
                                <ul class="nav nav-tabs">
                                    <li class="nav-item">
                                        <b-row>
                                       <a @click="activeTab = 0" class="nav-link" :class="{'active' : isActiveTab(0)}">
                                           <b-button variant="primary" class="" style="border-radius: 10px; padding: 5px 32px;">
                                             <span style="font-size: 2em; font-weight: bold; border-radius: 10px; padding: 5px 32px;">{{ this.pendingCount }}</span> <br> <br>
                                             <span :class="{'active-title': isActiveTab(0), 'inactive-title': !isActiveTab(0)}">
                                               Employee Request
                                             </span> <br>
                                             <span style="color: black;">
                                               FC Clock
                                             </span>
                                           </b-button>
                                         </a>
                                         
                                         <a @click="activeTab = 1" class="nav-link" :class="{'active' : isActiveTab(1)}">
                                           <b-button variant="primary" class="" style="border-radius: 10px; padding: 5px 32px;">
                                             <span style="font-size: 2em; font-weight: bold;">{{ this.incidentCount}}</span> <br> <br>
                                             <span :class="{'active-title': isActiveTab(1), 'inactive-title': !isActiveTab(1)}">
                                               Incident Master
                                             </span> <br>
                                             <span style="color: black;">
                                               incident master
                                             </span>
                                           </b-button>
                                         </a>
                                    </b-row>
                                 </li>
                             </ul>
                                <span style="color: red;">*Select a tile to view details*</span>

                            </div>
                        <b-col md="12" >
                            <div class="tab-panel" v-if="isActiveTab(0)">
                            <Employeerequest :displayPending="'yes'"></Employeerequest>   
                            </div>
                  
                            <div class="tab-panel" v-if="isActiveTab(1)">
                              <open_incident :displayIncident="'yes'"></open_incident>
                             </div>
                        </b-col> 
                       </b-col>
                     </b-row>      

                </b-card>
            </b-col>
        </b-row>
</div>            
</template>
<script>
import CONSTANTS from '../utils/constants'
import Employeerequest from './employeerequest.vue'
import open_incident from './open_incident'
export default {
    name: 'requestConfig',
    data: function() {
        return {
            activeTab:null,
            Employeerequest,
            open_incident,
            pendingCount:0,
            incidentCount:0,
        }
    },
    components: {
        Employeerequest,
        open_incident,
    },
    created: function() {
    this.pendingRequestCount();
    this.incidentMasterCount();
  },
    methods: {
  	isActiveTab(id)
    {
       return this.activeTab === id
    },
  

  pendingRequestCount() {   
   
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getPendingRequestCount`).then(result => {
        
        if (result.body.returnmsg === 'Successful') {
          this.pendingCount = result.body.returnvalue;
        } else {
          this.pendingCount=0;
        }
        console.log(" this.pendingCount-->>", this.pendingCount);
      }).catch(ex => {
        console.error('Error:', ex);
      })

    },

    incidentMasterCount() {   
        const obj = {
             hubid: [],
            incidentlevel: null,
             report_status: "open",
             searchparams: []
            }
   
   this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/incidentReportList`,obj).then(result => {
     
     if (result.body.returnmsg === 'Successful') {
       this.incidentCount = result.body.returnvalue.length;
     } else {
       this.incidentCount=0;
     }
     console.log(" this.pendingCount-->>", this.incidentCount);
   }).catch(ex => {
     console.error('Error:', ex);
   })

 }

   },
}

</script>
<style scope>
.requestconfig .nav-tabs .nav-link.active {
    border-bottom-color: #fff !important;
    border-color: #fff !important;

}
.requestconfig .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus{
    border-bottom-color: #fff !important;
    border-color: #fff !important;
}
.requestconfig .nav-tabs {
     border-bottom: none !important;
}
.active-title {
    color: white;
    font-weight: bold;
}

.inactive-title {
    color: black;
    font-weight: bold;
}

</style>